import _ from 'lodash'

export function getAvailableModifiers (menuBlob) {
  const availableModifiers = []
  getActiveModifierCategories(menuBlob)
    .forEach(category => {
      availableModifiers.push({
        id: category.id,
        name: category.info.name,
        displayName: category.info.displayName,
        imageId: category.info.imageId,
        $added: category.$added,
        items: [...getActiveModifierCategoryItems(category.id, menuBlob)
          .map(item => {
            return {
              id: item.id,
              name: item.info.name,
              displayName: item.info.displayName,
              menuButton: item.info.menuButton,
              imageId: item.info.imageId,
              $added: item.$added
            }
          })]
      })
    })
  return availableModifiers
}

export function getModifierCategories (menuBlob) {
  return _.get(menuBlob, 'modifiers.categories', [])
}

export function getActiveModifierCategories (menuBlob) {
  return getModifierCategories(menuBlob).filter(it => it.info.status === 'ACTIVE')
}

export function getModifierCategory (categoryId, menuBlob) {
  return getModifierCategories(menuBlob).find(it => it.id === categoryId)
}

export function getModifierCategoryItems (categoryId, menuBlob) {
  return getModifierItems(menuBlob).filter(it => it.category === categoryId)
}

export function getActiveModifierCategoryItems (categoryId, menuBlob) {
  return getModifierItems(menuBlob).filter(it => it.category === categoryId && it.info.status === 'ACTIVE')
}

export function getModifierItems (menuBlob) {
  return _.get(menuBlob, 'modifiers.items', [])
}

export function getActiveModifierItems (menuBlob) {
  return getModifierItems(menuBlob).filter(it => it.info.status === 'ACTIVE')
}

export function getModifierItem (itemId, menuBlob) {
  return getModifierItems(menuBlob).find(it => it.id === itemId)
}

export function getModifierItemCategoryId (itemId, menuBlob) {
  return _.get(getModifierItem(itemId, menuBlob), 'category', null)
}

export function getModifierItemCategory (itemId, menuBlob) {
  return getModifierCategory(getModifierItemCategoryId(itemId, menuBlob), menuBlob)
}
